import {
  FacilityResponse,
  FacilityStats,
  FacilityUpdate,
  HealthcareFacilityStats,
} from "../types/facility.definition";
import {
  getHealthcareFacilityById,
  getHealthcareFacilityStatistics,
  getStaffStatsByFacilityId,
  updateHealthcareFacility,
} from "../webclients/facility.client";

export const facilitiesApi = {
  fetchFacilityStats: async (id: number): Promise<HealthcareFacilityStats> => {
    const response = await getHealthcareFacilityStatistics(id);
    return response.data;
  },
  updateFacility: async (
    id: number,
    data: Partial<FacilityUpdate>
  ): Promise<FacilityResponse> => {
    const response = await updateHealthcareFacility(data, id);
    return response.data;
  },

  getFacilityById: async (id: string | number): Promise<FacilityResponse> => {
    const response = await getHealthcareFacilityById(Number(id));
    return response.data;
  },

  getFacilityStaffStats: async (id: string | number): Promise<FacilityStats> => {
    const response = await getStaffStatsByFacilityId(Number(id));
    return response.data;
  }
};
